<template>
  <div class="app-main-inner app-main-page basic-data">
    <el-container class="app-main-inner-row" style="background: white">
      <el-aside
        class="inner-box"
        style="width:fit-content;height:calc(100vh - 210px);overflow-x: hidden;margin-top: 60px"
      >
        <el-radio-group v-model="currentBar" style="display: flex;flex-direction: column" @change="barChange">
          <el-radio
            v-for="(item,index) in navigationBars"
            :key="index"
            :label="item.value"
            style="line-height:30px;"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-aside>
      <el-main style="padding:0px;flex: 1">
        <crm-customer-type v-show="currentBar === 'CustomerType'" ref="customerType" />
        <customer-contact-channel v-show="currentBar === 'CustomerContactChannel'" ref="customerContactChannel" />
        <customer-rating v-show="currentBar === 'CustomerRating'" ref="customerRating" />
        <difficulty-index v-show="currentBar === 'DifficultyIndex'" ref="difficultyIndex" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import CrmCustomerType from '@/views/cargo/v0/Sales/components/CrmSetting/crmCustomerType.vue'
import CustomerContactChannel from '@/views/cargo/v0/Sales/components/CrmSetting/customerContactChannel.vue'
import CustomerRating from '@/views/cargo/v0/Sales/components/CrmSetting/customerRating.vue'
import DifficultyIndex from '@/views/cargo/v0/Sales/components/CrmSetting/difficultyIndex.vue'

export default {
  name: 'BasicData',
  components: {
    CrmCustomerType,
    CustomerContactChannel,
    CustomerRating,
    DifficultyIndex
  },
  data() {
    return {
      navigationBars: [],
      currentBar: ''
    }
  },
  created() {
    const bars = []
    bars.push({ label: '客户类型', englishLabel: 'Customer Type', value: 'CustomerType' })
    bars.push({ label: '客户接触渠道', englishLabel: 'Customer Contact Channel', value: 'CustomerContactChannel' })
    bars.push({ label: '客户评定等级', englishLabel: 'Customer Rating', value: 'CustomerRating' })
    bars.push({ label: '攻克难度指数', englishLabel: 'Difficulty Index', value: 'DifficultyIndex' })
    if (this.$i18n.locale !== 'zh') {
      bars.forEach(function(item) {
        item.label = item.englishLabel
      })
    }
    this.navigationBars = bars
    this.currentBar = 'CustomerType'
  },
  mounted() {
    this.barChange()
  },
  methods: {
    barChange() {
      switch (this.currentBar) {
        case 'CustomerType':
          this.$refs.customerType.onShow()
          break
        case 'CustomerContactChannel':
          this.$refs.customerContactChannel.onShow()
          break
        case 'CustomerRating':
          this.$refs.customerRating.onShow()
          break
        case 'DifficultyIndex':
          this.$refs.difficultyIndex.onShow()
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss">
.basic-data {
  /*--滚动条样式 begin--*/
  .el-main{
    &>div{
      display: flex;
      flex-direction: column;
      height: 100%;
      .row-grid{
        flex-grow: 1;
      }
    }
  }
  .inner-box {
  }

  .inner-box::-webkit-scrollbar,
  .el-dialog__wrapper::-webkit-scrollbar {
    /*滚动条整体样式，宽高分别对应横竖滚动条的尺寸*/
    width: 6px;
    height: 6px;
  }

  .inner-box::-webkit-scrollbar-thumb,
  .el-dialog__wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 3px;
    background-color: #545557;
  }

  .inner-box::-webkit-scrollbar-track,
  .el-dialog__wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background-color: #dcdfe6;
  }

  /*--滚动条样式 end--*/
}
</style>
